module.exports = __webpack_public_path__ + "img/cogwheel-svgrepo-com.b44ab2d8.svg";